import { IParams } from '../..';

export const SALE_SUBURBAN_ORDER: (keyof IParams)[] = [
  'area', // Площадь
  'houseMaterial', // Тип дома
  'suburbanUtilities', // Наличие коммуникаций
  'landStatus', // Статус участка
  'heating', // Тип отопления
  'floorsTotal', // Этажей  в доме
  'bedrooms', // Спален в доме
  'facilities', // Удобства
  'suburbanBathroom', // Санузел
  'layout', // Планировка
  'houseYear', // Год постройки
  'undergroundTime', // До метро
  'publish', // Дата публикации
  'wordsInclude', // Содержит слова в объявлении
  'wordsExclude', // Исключить объявления со словами
  'phone', // Поиск по номеру телефона
  'offerId', // Поиск по номеру объявления
];
